import type { DocumentWithLinks } from '@contentful-components/rich-text/render'
import type {
    MarkdownFragment,
    TextFragment,
} from '@graphql/fragments/PolicyFragment.graphql'
import dynamic from 'next/dynamic'

export const PolicySections = dynamic(() => import('./policy-sections'))

export type PolicySectionsType = (
    | (TextFragment & {
          content: DocumentWithLinks
      })
    | (MarkdownFragment & {
          content: DocumentWithLinks
      })
)[]
